define('services/user',[
    'underscore',
    'backbone',
    'moment',
    'utils',
    'bootbox',
    //services
    'services/events/user-events',
    'services/session',
    'services/i18n',
    'services/firebase.service',
    'services/platform.service',
    // models
    'models/member/profile',
    // collections
    'collections/onboarding/tutorials'
], function(_, Backbone, moment, U, Bootbox, UserEvents, Session, i18n, FirebaseService, PlatformService, MProfile, COnboardingTutorials) {

    var defaults = {
        refreshDelay: 5 * 60 * 1000, // 5 minutes
    };

    var User = MProfile.extend({

        /**
         * False if the promise is pending, or the last fetch was within the delay.
         * Force a new fetch if the lang has changed since the last fetch.
         * @return {Boolean} fetch is needed
         */
        isFetchDue: function() {
            var lastFetch = this.lastFetch,
                promise = this.promise,
                isPending = promise && promise.state() === "pending";

            return !isPending && !lastFetch || // not fetched yet?
                moment().diff(lastFetch, 'hours') > this.fetchDelay; // is delay passed?
        },

        fetch: function(options) {
            options = options || {};
            if (this.isFetchDue() || options.force) {
                this.setId('me', { silent: true });
                this.promise = User.__super__.fetch.call(this, {
                    context: this,
                    success: this._onSync,
                    error: this._onError
                });
            }
            return this.promise;
        },

        initIntercom: function() {
            // Only enable Intercom in production
            if (window.env.NODE_ENV === 'prod' && this.getMainGroup().isSupervisor) {
                window.Intercom('boot', this.getIntercomAttributes());
            }
        },

        setSelectedUser: function(usr) {
            this.selectedUserByCoach = usr;
        },

        getCurrentlySelectedUser: function() {
          if (!this.selectedUserByCoach || !this.get('_mainGroup').isSupervisor)
            return this;
          else
            return this.selectedUserByCoach;
        },

        checkBrandColor: function() {
          //if invalid color, default blue TC
          if (!/^#[0-9A-F]{6}$/i.test(this.get("backgroundColor"))) {
            this.set("backgroundColor", '#00adef');
            //this.save();
          }
        },

        canHideItems: function() {
            return this.getSupervisorGroup().daysBeforeCalendarItemsAreHidden;
        },

        saveWebToken: function(token) {
            if (this.get('firebaseWebToken') !== token) {
                this.save({
                    firebaseWebToken: token
                }, {
                    patch: true
                })
            }
        },

        _onSync: function() {
            // Push notifications for mobile (Capacitor)
            if (PlatformService.isNative() || FirebaseService.isNative()) {
                var self = this;
                
                // Listen for token refresh
                FirebaseService.onTokenRefresh(function(token) {
                    // Check permission
                    FirebaseService.hasPermission(function(hasPermission) {
                        if (hasPermission) {
                            if (self.get('firebaseToken') !== token) {
                                self.saveFirebaseToken(token);
                            }
                        } else {
                            // Request permission
                            FirebaseService.grantPermission(function(hasPermission) {
                                if (hasPermission && self.get('firebaseToken') !== token) {
                                    self.saveFirebaseToken(token);
                                }
                            });
                        }
                    });
                }, function(error) {
                    console.error('Token refresh error:', error);
                });
            }

            if (PlatformService.isWeb() && 'PushManager' in window) {
                var messaging = firebase.messaging();
                // Push notifications for Web
                messaging.getToken().then(this.saveWebToken.bind(this));

                // Monitor token refresh
                messaging.onTokenRefresh(function() {
                    messaging.getToken().then(this.saveWebToken.bind(this));
                }.bind(this));
            }

            var language = this.get('language').replace('_', '-');
            if (language !== U.getSavedLanguage()) {
                i18n.setLanguage(language, true);
                window.location.reload();
            }

            COnboardingTutorials.fetch();
            this.lastFetch = moment();
            this.initIntercom();
            UserEvents.fetchComplete();
            //redirection from old web site after registration "try/register"
            if (this.needPaymentCenter()) {
                Backbone.history.redirect("#/payment/forceModifyMethod/");
                return;
            }

            //this.checkBrandColor();

            //possible values -> false, expiredInAllGroup, expiredInAGroupButActiveInOne
            var expiredGroupStatus = this.isMemberOfExpiredGroup();

            switch (expiredGroupStatus) {
                case "expiredInAGroupButActiveInOne":
                    document.cookie = "TCNeddExpirationToastr=true";
                    break;
                case "expiredInAllGroup":
                    if (Backbone.history.getFragment().indexOf('payment/expired') < 0) {
                        Backbone.history.redirect("#/payment/expired/");
                    }
                    break;
            }

            // Prevent redirection if the user is opening a questionnaire url
            if (Backbone.history.getFragment().includes('questionnaires')) {
                return;
            }

            if (this.getMainGroup().isSupervisor) {
                Backbone.history.redirect("supervisor");
            } else {
                Backbone.history.redirect("#/");
            }
        },

        _onError: function(model, xhr, options) {
            window.Rollbar.error("Service/User.js in fetch\n" + "model: " + JSON.stringify(model) + "\nxhr: " + JSON.stringify(xhr) + "\noptions: " + JSON.stringify(options));
            this.lastFetch = null;
        },

        saveFirebaseToken: function(value) {
            this.save({
                firebaseToken: value
            }, {
                patch: true
            })
        }
    });

    var user = new User();

    return user;
});

